import AudioCoherenceTraining from "../components/activities/ACT/AudioCoherenceTraining";
export const ActivityLookupTable = {
    'mpa-audio-number-patterns': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'sequences'
        },
    },
    'mpa-audio-number-patterns-dev': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'sequences'
        },
    },
    'mpa-dont-zone-out': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'concentration_games',
            score_multiplier: 3
        },
    },
    'mpa-follow-the-lights': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'sequences'
        },
    },
    'mpa-heres-a-story': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'standard'
        },
    },
    'mpa-reverse-audio-number-patterns': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'sequences'
        },
    },
    'mpa-reverse-visible-number-patterns': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'sequences'
        },
    },
    'mpa-symbol-match': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'concentration_games',
            score_multiplier: 13
        },
    },
    'mpa-visual-number-patterns': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'sequences'
        },
    },
    'mpa-word-recall': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'standard'
        },
    },
    'mpa-survey': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'survey'
        },
    },
    'mpt-arrow-switch': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'one_to_one'
        },
    },
    'mpt-did-you-hear-that': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'score_from_highest_level',
            score_increment: 89,
            total_rounds: 9
        },
    },
    'mpt-did-you-hear-that-reverse': {
        component: undefined,
        scoringSettings: {
            scoring: 'score_from_highest_level',
            score_increment: 89,
            total_rounds: 9
        },
        hasScoring: 1,
    },
    'mpt-hidden-words': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'amount_true_time_multiplier_scoring',
            score_multiplier: 32
        },
    },
    'mpt-random-sequence': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'score_from_highest_level',
            score_increment: 53,
            total_rounds: 15
        },
    },
    'mpt-red-light': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'concentration_games',
            score_multiplier: 5.369
        },
    },
    'mpt-subtle-differences': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'score_from_highest_level',
            score_increment: 40,
            total_rounds: 20
        },
    },
    'mpt-target-tracker': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'score_from_highest_level',
            score_increment: 80,
            total_rounds: 10
        },
    },
    'mpt-water-flower': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'score_from_highest_level',
            score_increment: 80,
            total_rounds: 10
        },
    },
    'mpt-water-flower-reverse': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'score_from_highest_level',
            score_increment: 80,
            total_rounds: 10
        },
    },
    'mpt-whats-new': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'score_from_highest_level',
            score_increment: 20,
            total_rounds: 40
        },
    },
    'cbc-hrv': {
        component: AudioCoherenceTraining,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Focused Breathing`,
            activityIntroHeader: `IT'S TIME TO STRETCH`,
            activityIntroBody: `Before each workout, we'll guide you through two minutes of Focused Breathing, which is a series of breathing exercises combined with specific audio tones. Why? It readies your brain, calling it to attention to get ready for your workout.`
        },
    },
    'ce-chess': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {},
    },
    'ce-fish': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {},
    },
    'ce-card-match': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {},
    },
    'ce-card-match-reverse': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {},
    },
    'ce-slide-puzzle': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {},
    },
    'ce-up-down': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {},
    },
    'mpt-word-or-color': {
        component: undefined,
        hasScoring: 1,
        webGame: false,
        gameUrl: '',
        scoringSettings: {
            scoring: 'amount_true_time_multiplier_scoring',
            score_multiplier: 13
        },
    },
    '2048': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/2048/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `2048`,
            activityIntroHeader: `Slide, Merge, and Reach 2048!`,
            activityIntroBody: `Test your puzzle-solving skills in 2048. Combine the numbered tiles until you reach the coveted 2048 tile. Can you achieve it?`,
            activitySubHeader: 'Game'
        },
    },

    'anagramica': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/anagramica/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `anagramica`,
            activityIntroHeader: `Unscramble Letters, Discover Words!`,
            activityIntroBody: `Anagramica challenges you to rearrange letters and find as many words as possible. Enhance your vocabulary and have fun!`,
            activitySubHeader: 'Game'
        },
    },
    
    'get-the-word': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/get-the-word/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Get the Word`,
            activityIntroHeader: `Guess the Word, Expand Your Mind!`,
            activityIntroBody: `Can you guess the hidden word? Test your language skills and learn new words along the way in Get the Word.`,
            activitySubHeader: 'Game'
        },

    },

    'backgammon': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/backgammon/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Backgammon`,
            activityIntroHeader: `Ancient Strategy, Modern Fun!`,
            activityIntroBody: `Enjoy the classic game of Backgammon, where strategy and luck meet. Play against the computer or challenge a friend!`,
            activitySubHeader: 'Game'
        },

    },

    'downhill-ski': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/downhill-ski/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Downhill Skiing`,
            activityIntroHeader: `Slope-Down Adventure Awaits!`,
            activityIntroBody: `Ski down the snowy slopes while avoiding obstacles. How far can you make it?`,
            activitySubHeader: 'Game'
        },

    },

    'game-of-15': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/game-of-15/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Game of 15`,
            activityIntroHeader: `Slide to Victory in Game of 15!`,
            activityIntroBody: `Engage in a classic sliding puzzle challenge.`,
            activitySubHeader: 'Game'
        },
    },

    'pinball': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/pinball/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Pinball`,
            activityIntroHeader: `Arcade Classic at Your Fingertips!`,
            activityIntroBody: `Experience the thrill of an arcade classic with Pinball. Hit the flippers, rack up points, and aim for the high score!`,
            activitySubHeader: 'Game'
        },

    },

    'solitaire': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/solitaire/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Solitaire`,
            activityIntroHeader: `The Timeless Card Sorting Challenge!`,
            activityIntroBody: `Relax with a game of Solitaire. Clear the table by sorting the cards in order and uncover the aces to win!`,
            activitySubHeader: 'Game'
        }
    },

    'streamline': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/streamline/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Streamline`,
            activityIntroHeader: `Fast-Paced Line Dodging Fun!`,
            activityIntroBody: `Dodge, dive, and weave through the lines in Streamline. How long can you last in this fast-paced evasion challenge?`,
            activitySubHeader: 'Game'
        },
    },

    'sudoku': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/sudoku/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Sudoku`,
            activityIntroHeader: `Engage Your Brain with Sudoku!`,
            activityIntroBody: `Fill in the grid so that every row, every column, and every 3x3 box contains the digits 1 through 9.`,
            activitySubHeader: 'Game'
        },
    },

    'word-search': {
        component: undefined,
        hasScoring: 0,
        webGame: true,
        gameUrl: 'https://cerebrocoreusa.com/games/word-search/',
        scoringSettings: {},
        startScreenProps: {
            activityName: `Word Search`,
            activityIntroHeader: `Find the Words, Sharpen Your Mind!`,
            activityIntroBody: `Discover the hidden words in a grid filled with letters. Challenge your observation skills and enjoy endless word-finding fun!`,
            activitySubHeader: 'Game'
        },
    },

};